import arenaCards from './arenaCards20221117202738.json';

export default arenaCards;
